<template>
  <div>
    <div class="contact-messenger-options">
      <div
        v-for="messenger in messengers"
        :key="messenger.name"
        class="contact-messenger-item"
        @click="selectMessenger(messenger.name)"
      >
        <img
          :src="messenger.icon"
          :alt="messenger.name"
          class="messenger-icon"
        />
        <span class="contact-messenger-item-name">{{ messenger.name }}</span>
      </div>
    </div>
    <div class="messenger-back-btn-container">
      <v-btn
        small
        rounded
        outlined
        color="primary"
        class="ml-8 mb-6 messenger-back-btn-content"
        @click="$emit('cancelMessengerSelectionAction')"
      >
       <span class="messenger-back-btn">{{ $t('common.back2') }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { MESSENGERS } from '@/constants/quiz'

export default {
  name: "MessengerSelection",

  data () {
    return {
      messengers: MESSENGERS,
    }
  },

  methods: {
    selectMessenger(messengerName) {
      this.$emit("selectMessenger", messengerName);
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-messenger-options {
  padding: 0 32px 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.messenger-back-btn-container .messenger-back-btn-content {
  height: 36px;
}

.contact-messenger-item {
  display: flex;
  padding: 20px 28px;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  align-self: stretch;
  border-radius: 16px;
  background: var(--v-background-primary-default-base);
  box-shadow: 0px 24px 30px -24px rgba(208, 206, 217, 0.40), 0px 0px 0px 1px rgba(61, 59, 53, 0.08), 0px 2px 6px 0px rgba(61, 59, 53, 0.06);
}

.contact-messenger-item:hover {
  background: var(--v-background-primary-hover-base);
}

.messenger-back-btn {
  padding: 10px 12px;
}

.contact-messenger-item-name {
  color: var(--v-text-primary-base);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
</style>
